import { pipe } from 'ramda';

const decode = pipe(decodeURIComponent, atob, JSON.parse);

export const decodeObjFromUriParam = (
  uriParam: string | null
): object | null => {
  if (uriParam == null) {
    return null;
  }

  let obj: object | null = null;

  try {
    obj = decode(uriParam);
  } catch {
    console.error('Invalid encoded string.');
  }

  return obj;
};
